import { forEach } from 'lodash';
import { UseFormReturn } from 'react-hook-form';
import { CellQuantificationJobConfig, QuantificationFormValues } from './types';

export const defaultsSyntheticSegmentationConfiguration: {
  name: string;
  defaultValues: Record<string, number | null>;
}[] = [
  {
    name: 'calculate both nuclear and cell compartments OD, with synthetic geometries for missing segmentation values',
    defaultValues: {
      'cellCompartmentParams.membraneOutwardsThicknessUm': 0.5,
      'cellCompartmentParams.membraneInwardsThicknessUm': 0.5,
      syntheticCytoplasmThicknessUm: 4.0,
      syntheticNuclearRadiusUm: 4.0,
      syntheticMembraneErosionFactor: 0.25,
    },
  },
  {
    name: 'calculate both nuclear and cell compartments OD, without synthetic geometries for missing segmentation values',
    defaultValues: {
      'cellCompartmentParams.membraneOutwardsThicknessUm': 0.5,
      'cellCompartmentParams.membraneInwardsThicknessUm': 0.5,
      syntheticCytoplasmThicknessUm: null,
      syntheticNuclearRadiusUm: null,
      syntheticMembraneErosionFactor: null,
    },
  },
  {
    name: 'calculate nuclear OD only, with synthetic geometries for missing segmentation values',
    defaultValues: {
      'cellCompartmentParams.membraneOutwardsThicknessUm': 0,
      'cellCompartmentParams.membraneInwardsThicknessUm': 0,
      syntheticCytoplasmThicknessUm: 4.0,
      syntheticNuclearRadiusUm: null,
      syntheticMembraneErosionFactor: null,
    },
  },
  {
    name: 'calculate nuclear OD only, without synthetic geometries for missing segmentation values',
    defaultValues: {
      'cellCompartmentParams.membraneOutwardsThicknessUm': 0,
      'cellCompartmentParams.membraneInwardsThicknessUm': 0,
      syntheticCytoplasmThicknessUm: null,
      syntheticNuclearRadiusUm: null,
      syntheticMembraneErosionFactor: null,
    },
  },
];

export const defaultsSyntheticSegmentationForMIF = 2;
export const defaultsSyntheticSegmentationNonMIF = 0;

export const setDefaultSyntheticSegmentationValues = (
  caseIndex: number,
  methods: UseFormReturn<QuantificationFormValues, any>
) => {
  const defaultValues = defaultsSyntheticSegmentationConfiguration?.[caseIndex]?.defaultValues;
  forEach(defaultValues, (value, key) => {
    methods.setValue(`configParams.${key}` as `configParams.${keyof CellQuantificationJobConfig}`, value ?? null);
  });
};
